const CHECKBOX_PREFIX_REGEXP = /^[-*]?\s*\[(?: |x|X)\]\s*/;
const BULLET_PREFIX_REGEXP = /^[-*]\s+/;
const ORDERED_LIST_PREFIX_REGEXP = /^\d+[.)]?\s+/;

export const parseChecklistFromPlainText = (text: string): string[] =>
    text
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => line.replace(CHECKBOX_PREFIX_REGEXP, ''))
        .map((line) => line.replace(BULLET_PREFIX_REGEXP, ''))
        .map((line) => line.replace(ORDERED_LIST_PREFIX_REGEXP, ''))
        .map((line) => line.trim())
        .filter(Boolean);
